import axios from "axios";
import {urlParamsConfig} from "../../utils/ParamsUtils";
import {localStorageItem} from "../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../auth/core/_consts";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"]
  || process.env.REACT_APP_API_URL;
const API_PATH_REMEDIATION = API_PATH + "/remediation-plan";

export const getListCorrectivePlan = (params: any) => {
  const url = `${API_PATH_REMEDIATION}/search`;
  return axios.get(urlParamsConfig(url, params));
};

export const getCriteriaByPlan = (id: string = "", params?: any) => {
  const url = `${API_PATH_REMEDIATION}/by-plan-criteria/${id}`;
  return axios.get(url, {params});
};

export const getPlanDetail = (id: string = "", params?: any) => {
  const url = `${API_PATH_REMEDIATION}/${id}`;
  return axios.get(url, {params});
};

export const getLogAssessment = (params: any) => {
  const url = `${API_PATH}/log-assessment/by-assessment`;
  return axios.get(urlParamsConfig(url, params));
};

export const updateRemediationPlan = (id: string = "", data: any = {}) => {
  const url = `${API_PATH_REMEDIATION}/${id}`;
  return axios.put(url, data);
};

export const completeRemediationPlan = (id: string = "", data: any = {}) => {
  const url = `${API_PATH_REMEDIATION}/${id}/complete`;
  return axios.put(url, data);
};
